import { Image } from "@chakra-ui/react";

import { GridItemType } from "components/Chakra/Card/CardMotion";
import CustomLink from "components/Chakra/CustomLink";
import Card from "../Card";

export const secondTabItems: Array<GridItemType> = [
  {
    content: (
      <Card
        title="Virtuální prohlídka díky 3D scanu představí nemovitosti realisticky a profesionálně"
        subTitle="Díky několika snímkům sestavíme přesný a kompletní 3D model nemovitosti. Prohlížející se může procházet po celé nemovitosti online a předejde se zbytečným prohlídkám."
        buttonText="Zobrazit ukázku"
      />
    ),
    isGalerryIcon: false,
    filterBrightnessPercent: 60,
    gridItemSetting: { name: "A", h: { base: "360px", md: "555px" } },
  },
  {
    content: (
      <CustomLink
        href="https://my.matterport.com/show/?m=U9DXoKMmBDD"
        target="_blank"
      >
        <Image
          src="/img/scenes/Matterport/nahled.png"
          alt="3Dscan"
          objectFit="cover"
          h={{ base: "200px", md: "555px" }}
          w="100%"
          borderRadius="16px"
        />
      </CustomLink>
    ),
    gridItemSetting: { name: "B", h: { base: "360px", md: "555px" } },
    filterBrightnessPercent: 60,
  },
];
